module.exports = __webpack_public_path__ + "img/spaceman.6f7df52c.png";